import { useNavigate } from 'react-router-dom';
import { Eye } from 'lucide-react';
import type { JobStatus } from '@/types';

// ─── Types ──────────────────────────────────────────────────────────────────

interface JobRowActionsProps {
  jobId: string;
  status: JobStatus;
}

// ─── Component ───────────────────────────────────────────────────────────────

/**
 * Per-row action buttons in the Recent Jobs table.
 * Currently exposes a single "View" action. Cancel is surfaced on the Job
 * Detail page once the full job actions flow is implemented.
 */
export function JobRowActions({ jobId }: JobRowActionsProps) {
  const navigate = useNavigate();

  return (
    <div className="flex items-center gap-1">
      <button
        type="button"
        aria-label="View job details"
        onClick={(e) => {
          e.stopPropagation();
          navigate(`/jobs/${jobId}`);
        }}
        className="inline-flex items-center gap-1 rounded px-2 py-1 text-xs font-medium text-muted-foreground hover:bg-accent hover:text-accent-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring transition-colors"
      >
        <Eye className="h-3.5 w-3.5" aria-hidden="true" />
        View
      </button>
    </div>
  );
}
